<template>
  <div class="box">
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <span>工作区默认权限白名单</span>
        <el-button style="float: right;" type="primary" size="small" @click="openDialog">配置白名单</el-button>
      </div>
      <el-alert
        type="warning"
        :closable="false"
        show-icon
        style="margin-bottom: 16px;"
        title="该名单作用于根目录「项目申报」「客户审核资料」及其所有子孙节点；新建文件/文件夹会自动继承，无需再次授权。"
      />
      <el-table :data="tableData" v-loading="loading" border stripe>
        <el-table-column type="index" label="#" width="60" />
        <el-table-column prop="subjectType" label="主体类型" width="120">
          <template slot-scope="scope">
            {{ { 0: '人员', 1: '部门', 2: '角色' }[scope.row.subjectType] || scope.row.subjectType }}
          </template>
        </el-table-column>
        <el-table-column prop="subjectId" label="主体ID" width="140" />
        <el-table-column prop="createBy" label="创建人" width="140" />
        <el-table-column prop="createTime" label="创建时间" />
      </el-table>
    </el-card>
    <workspace-whitelist-dialog ref="whitelistDialog" @ok="loadData" />
  </div>
</template>

<script>
export default {
  name: 'workspace_whitelist_list',
  components: {
    WorkspaceWhitelistDialog: () => import('@/components/folder/workspaceWhitelistDialog.vue')
  },
  data() {
    return {
      loading: false,
      tableData: []
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$HttpService.get('/workspace-whitelist/list')
        .then(res => {
          this.tableData = Array.isArray(res) ? res : []
        })
        .finally(() => {
          this.loading = false
        })
    },
    openDialog() {
      this.$refs.whitelistDialog.open()
    }
  }
}
</script>
